import {
  getObject,
  getInt32,
} from "@surya-digital/leo-ts-types";
import { QuartileColorWithHexCodes, QuartileColorWithHexCodesDTO } from "./quartileColorWithHexCodes";
import { QuartileRange } from "./quartileRange";

export interface QuartileConfigurationDTO {
  quartileColor: QuartileColorWithHexCodesDTO;
  quartileRange: QuartileRange.QuartileRangeDTO;
  serialNumber: number;
}

export class QuartileConfiguration {
  readonly isQuartileConfigurationQuartileConfiguration: boolean = true;

  readonly quartileColor: QuartileColorWithHexCodes;
  readonly quartileRange: QuartileRange.QuartileRange;
  readonly serialNumber: number;


  constructor(
  quartileColor: QuartileColorWithHexCodes, 
  quartileRange: QuartileRange.QuartileRange, 
  serialNumber: number
  ) {
    this.quartileColor = quartileColor;
    this.quartileRange = quartileRange;
    this.serialNumber = serialNumber;
  }

  static fromDTO(dto: QuartileConfigurationDTO): QuartileConfiguration {
    const quartileColor = QuartileColorWithHexCodes.fromDTO(getObject(dto, "quartileColor", InvalidQuartileConfigurationQuartileColorError));
    const quartileRange = QuartileRange.fromDTO(getObject(dto, "quartileRange", InvalidQuartileConfigurationQuartileRangeError));
    const serialNumber = getInt32(dto, "serialNumber", InvalidQuartileConfigurationSerialNumberError);
    return new QuartileConfiguration(
      quartileColor,
      quartileRange,
      serialNumber
    );
  }

  toDTO(): QuartileConfigurationDTO {
    const dto: QuartileConfigurationDTO = {
        quartileColor: this.quartileColor.toDTO(),
        quartileRange: this.quartileRange.toDTO(),
        serialNumber: this.serialNumber
    };
    return dto;
  }
  }

QuartileConfiguration.prototype.toString = function toString(): string {
  return `QuartileConfiguration(quartileColor='${this.quartileColor}',quartileRange='${this.quartileRange}',serialNumber='${this.serialNumber}')`;
};

export class InvalidQuartileConfigurationError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuartileConfigurationError";
  }
}
export class InvalidQuartileConfigurationQuartileColorError extends InvalidQuartileConfigurationError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuartileConfigurationQuartileColorError";
  }
}

export class InvalidQuartileConfigurationQuartileRangeError extends InvalidQuartileConfigurationError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuartileConfigurationQuartileRangeError";
  }
}

export class InvalidQuartileConfigurationSerialNumberError extends InvalidQuartileConfigurationError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuartileConfigurationSerialNumberError";
  }
}
